import { Label,Hint,Error } from '@progress/kendo-react-labels';
import { Input } from '@progress/kendo-react-inputs';
import { useUserResponseCtx } from '../../../Context/SurveyContext';
import { useGlobalCtx } from '../../../Context/GlobalContext';
import { useBlockCtx } from '../../../Context/BlockContext';

interface BlockSumToProps {
    id:number,
    sumToTotal:number
}

export const BlockSumTo = (props:BlockSumToProps) => {
    const globalCTX = useGlobalCtx()
    let userBlockCtx = useBlockCtx()
    let userResCtx = useUserResponseCtx()
    function HintOrError() {
        if(props.sumToTotal !== userBlockCtx.CurrentSumToValue && userResCtx.current.length > 0)
            return <Error direction='start'>{globalCTX.LangResources.blockMsg.sumToError.replace('{sumto}',props.sumToTotal)}</Error>
        else if(props.sumToTotal === userBlockCtx.CurrentSumToValue)  
            return <Hint className="font-bold text-lime-700">{globalCTX.LangResources.blockMsg.sumToSuccess.replace('{sumto}',props.sumToTotal)}</Hint>   
        else
            return <Hint>{globalCTX.LangResources.blockMsg.sumToHint.replace('{sumto}',props.sumToTotal)}</Hint>
    }

    return(
        <div>
        <Label className="text-xl font-semibold" id={'BlockSumToLabel'+props.id} editorId={'BlockSumToValue'+props.id}>{globalCTX.LangResources.blockMsg.sumToLabel}</Label>
        <Input id={'BlockSumToValue'+props.id} value={userBlockCtx.CurrentSumToValue} disabled={true}/>
        {<HintOrError/>}
        </div>
    );
}